import { createContext, useContext } from 'react';
import { I18nContextType } from '../types/i18n.types';

export const I18nContext = createContext<I18nContextType | undefined>(undefined);

export const useI18nContext = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18nContext must be used within I18nProvider');
  }
  return context;
};